import * as React from 'react';

// TODO: CHANGE TO 'DESC '
type sortDirection = 'ascending' | 'descending'

interface GenDirectionButtonProps {
  disabled: boolean;
  value: string;
  title: string;
}

interface GenDirectionalButtonsProps {
  buttons: Array<GenDirectionButtonProps>,
  disabled?: boolean,
  onUpdate: (value: string, direction: sortDirection) => void,
  selectedDirection: sortDirection,
  selectedValue: string,
}

export default function GenDirectionalButtons({
  buttons,
  disabled,
  onUpdate,
  selectedDirection,
  selectedValue,
}: GenDirectionalButtonsProps) {
  const onButtonClick = (value: string) => {
    let direction: sortDirection = 'ascending';
    if (selectedValue === value) {
      direction = selectedDirection === 'ascending' ? 'descending' : 'ascending';
    }

    onUpdate(value, direction);
  };

  const renderedButtons = buttons.map((button) => {
    let classes = "gen-directional-button";
    let spanClasses = "bg-sky-600 hover:bg-sky-500"

    if (disabled || button.disabled) {
      classes += " disabled";
    }

    if (button.value === selectedValue) {
      classes += " selected " + selectedDirection;
    } else {
      spanClasses = "bg-white hover:bg-slate-100"
    }

    // TODO: CHANGE TO BUTTON NOT DIV
    return(
      <div className={classes} key={button.value} onClick={() => onButtonClick(button.value)}>
        <span className={spanClasses}>{button.title}</span>
      </div>
    );
  })

  return (
    <div className="gen-directional-buttons">
      {renderedButtons}
    </div>
  );
}
